import { SVGProps } from 'react'

export enum NavigatoinBarItem {
    HomePage = 'homepage',
    Categories = 'categories',
    Cart = 'cart',
    Profile = 'profile',
}

export interface NavigationBarItemType {
    id: NavigatoinBarItem
    title: string
    href: string
    default_icon: (props: SVGProps<SVGSVGElement>) => JSX.Element
    active_icon: (props: SVGProps<SVGSVGElement>) => JSX.Element
}
